import { useCallback, useEffect, useState } from 'react';

import { WorkItemAnnotation, WorkItemNote } from './workQueueLists';
import axios from 'axios';

export type DepartmentRelation = 'blocked' | 'deep' | 'other';

export interface ProviderDepartmentItem {
  departmentId: string;
  departmentName: string | null;
  relation: DepartmentRelation;
  annotation: WorkItemAnnotation | null;
}

export interface ProviderWorkItems {
  npi: string;
  providerName: string | null;
  snapshotDate: string | null;
  effectiveStatus: string | null;
  priority: 'P1' | 'P2' | 'P3' | null;
  coveredByDepartmentItem: { departmentId: string; status: string } | null;
  annotation: WorkItemAnnotation | null;
  notes: WorkItemNote[];
  departments: ProviderDepartmentItem[];
}

/** The work-queue items for one provider and its departments, for the profile page. */
export function useProviderWorkItems(npi: string | undefined) {
  const [data, setData] = useState<ProviderWorkItems | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!npi) return;
    setLoading(true);
    try {
      const response = await axios.get<ProviderWorkItems>(`/api/epic-blocks/work-items/provider/${npi}`, {
        withCredentials: true
      });
      setData(response.data);
      setError(null);
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Could not load the work-queue items.');
    } finally {
      setLoading(false);
    }
  }, [npi]);

  useEffect(() => {
    setData(null);
    reload();
  }, [reload]);

  return { data, loading, error, reload };
}
